// extracted by mini-css-extract-plugin
module.exports = {"root":"ModalInventoryLogs_root__2Begz","log":"ModalInventoryLogs_log__1ndpN","date":"ModalInventoryLogs_date__3Jx-X","userName":"ModalInventoryLogs_userName__BjUv5"};